"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const LoadingOverlay = ({ isLoading }) => {
    return (react_2.default.createElement(react_1.AbsoluteCenter, { transition: 'all 250ms ease-in-out', width: '100%', height: '100%', opacity: isLoading ? 1 : 0, backdropFilter: 'blur(2px)', visibility: isLoading ? 'visible' : 'hidden', "data-testid": "loading-overlay" },
        react_2.default.createElement(react_1.Box, { width: '100%', height: '100%', position: 'absolute' },
            react_2.default.createElement(react_1.AbsoluteCenter, null,
                react_2.default.createElement(react_1.Spinner, null)))));
};
exports.LoadingOverlay = LoadingOverlay;
